import React from 'react';
import CartTable from './components/CartTable';
import CartFooter from './components/CartFooter';
import Header from '../../components/Header';
import { useRecoilValue } from 'recoil';
import { addToProjectAtom } from '../../state';
import { IProduct } from '../../types';
import CustomizeHeader from '../../components/CustomizeHeader';

const Cart = () => {

  const selectedProducts = useRecoilValue<IProduct[] | any>(addToProjectAtom);

  const renderEmptyCart = () => {
    return (
      <div className="flex flex-col items-center justify-center py-16 px-4">
        {/* Empty Cart Icon */}
        <div className="mb-8">
          <img
            src={'/cart.svg'} // Default image, you can make this dynamic
            className="w-[45px] h-[45px]"
            alt={`cart selection`}
          />
        </div>

        {/* Empty Cart Message */}
        <div className="text-center mb-8">
          <h2 className="text-2xl sm:text-3xl font-bold text-gray-900 mb-4">
            Your cart is empty
          </h2>
          <p className="text-gray-600 text-base sm:text-lg max-w-md mx-auto">
            Looks like you haven't added any products to your cart yet. Start shopping to discover our amazing collection!
          </p>
        </div>
      </div>
    );
  };

  return (
    <div className="min-h-screen bg-white">
      <div className="sticky top-0 z-50">
        <Header />
      </div>
      <CustomizeHeader text='Your Selected Items' />
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 pt-2 pb-8">
        {selectedProducts && selectedProducts.length > 0 ? (
          <div className="overflow-x-auto">
            <CartTable />
          </div>
        ) : (
          renderEmptyCart()
        )}
        {selectedProducts && selectedProducts.length > 0 && <CartFooter />}
      </div>
    </div>
  );
};

export default Cart; 